import { buildExecutionContext } from 'graphql/execution/execute'

const meta = {
  requiresAuth: true,
}

export default [
  {
    component: () => {
      return import(/* webpackChunkName: "main" */ '@/views/interview-booking/BookInterview.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_patient_account: true } },
        { userMatches: { is_coordinator_account: true } },
      ],
      layout: 'blue',
    },
    name: 'interviewBooking',
    path: '/interviews/booking',
  },
  {
    component: () => {
      return import(/* webpackChunkName: "main" */ '@/views/interview-booking/ManageTimeSlots.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_coordinator_account: true } },
      ],
      layout: 'blue',
    },
    name: 'manageTimeSlots',
    path: '/interviews/manage',
  },
  {
    component: () => {
      return import(/* webpackChunkName: "main" */ '@/views/interview-booking/Report.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_coordinator_account: true } },
      ],
      layout: 'blue',
    },
    name: 'interviewReports',
    path: '/interviews/reports',
  },
]
